export default "__VITE_ASSET__Big5u3eC__"